import { Container } from 'destination-result-list';
var productsPromise = import('../Helper/Products');
import { DestinationType, store } from 'ltur-state-engine';
import Vue from 'vue';
import initializeUserSorting from "Entries/userSortingEntry";
var initializeDestinationResultList = function () {
    var initialized = false;
    store.subscribe(function () {
        productsPromise.then(function (module) {
            if (!initialized && module.default.isStateReadyForProductQuery()) {
                initialized = true;
                initializeUserSorting(DestinationType.DESTINATION);
                module.default.getGroupsAsync(DestinationType.DESTINATION);
                module.default.getGroupQueryOptionsAsync();
            }
        });
    });
    new Vue({
        render: function (h) { return h(Container); },
    }).$mount('#destinationResultList');
};
export default initializeDestinationResultList;
